import { Navigate, RouteObject, useRoutes } from 'react-router-dom';
import Game from './Game';
import GamePc from './GamePc';
import ListGiaPage from './ListGiaPage';
import Message from './Message';

const width = window.innerWidth;
const WebManagementLayout: RouteObject[] = [
  {
    path: "/game/:id/:userId",
    element: width < 768 ? <Game /> : <GamePc />,
  },
  {
    path: '/message/:userId',
    element: <Message />,
  },
  {
    path: "/list-gia",
    element: <ListGiaPage />,
  },
  { path: "*", element: <Navigate to="/404" /> },
];

const WapManagementRoutes = () => useRoutes(WebManagementLayout);
export default WapManagementRoutes;
